import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const EmptyDivider = styled.div`
  margin: ${props => `${props.size}px 0`}
`
EmptyDivider.propTypes = {
  size: PropTypes.number.isRequired
}

export default EmptyDivider
